let standardCrud = {
    read: {
        params: { action: 'get' }
    },
    create: {
        params: { action: 'create' }
    },
    update: {
        params: { action: 'update' }
    },
    destroy: {
        params: { action: 'delete' }
    }
}

export default {
    calendarEventType: {
        defaults: {
            endpoint: 'calendar.php',
            rootProperty: 'data'
        },
        ...standardCrud
    }
}